import { ArrowRight } from "lucide-react";
import CinematicButton from "@/components/CinematicButton";
import Reveal from "@/components/Reveal";

export default function CtaBanner() {
    return (
        <section className="py-20 lg:py-24" data-testid="cta-section">
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <Reveal>
                    <div className="relative overflow-hidden rounded-3xl bg-burgundy px-6 sm:px-16 py-20 lg:py-24 text-center">
                        {/* decorative rings */}
                        <span className="pointer-events-none absolute -right-24 -top-28 w-80 h-80 rounded-full border-[26px] border-olive/25" aria-hidden="true" />
                        <span className="pointer-events-none absolute -left-20 -bottom-28 w-72 h-72 rounded-full border-[22px] border-gold/20" aria-hidden="true" />
                        <span className="pointer-events-none absolute right-[12%] bottom-[8%] w-2 h-2 rotate-45 bg-gold" aria-hidden="true" />

                        <h2 className="relative text-4xl sm:text-5xl lg:text-6xl text-cream">
                            Have a Project <em className="italic text-gold">in Mind?</em>
                        </h2>
                        <p className="relative mt-5 text-cream/75 max-w-xl mx-auto">
                            Let's turn your idea into something valuable.
                        </p>
                        <div className="relative mt-10 flex flex-wrap items-center justify-center gap-4">
                            <CinematicButton
                                onClick={() => window.dispatchEvent(new Event("analytrova:open-popup"))}
                                className="btn btn-gold group"
                                testid="cta-get-started"
                            >
                                Get Started
                                <ArrowRight className="btn-arrow w-4 h-4" />
                            </CinematicButton>
                            <CinematicButton
                                href="#services"
                                className="btn btn-outline-cream group"
                                testid="cta-services"
                            >
                                View Our Services
                                <ArrowRight className="btn-arrow w-4 h-4" />
                            </CinematicButton>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
